module.exports = __webpack_public_path__ + "static/nada-Logo-7c0e144436d66362d19bafdf0f0656f2.png";